export default {
  RESET_USER_DATA: 'RESET_USER_DATA',
  UPDATE_STATE: 'UPDATE_STATE',
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE'
};
